exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.center[data-v-50fbd6aa] {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\n}\ntextarea .fullscreen[data-v-50fbd6aa] {\r\n    overflow: hidden;\r\n    width: 200px;\r\n    height: 50px;\r\n    padding: 0;\n}\r\n\r\n", ""]);

